import { createApp } from 'vue';
import App from './App.vue';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Panel from 'primevue/panel'
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import PrimeVue from 'primevue/config';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DynamicDialog from 'primevue/dynamicdialog';
import Sidebar from 'primevue/sidebar';
import ScrollPanel from 'primevue/scrollpanel';

import {FilterMatchMode,FilterOperator} from 'primevue/api';

import 'primevue/resources/themes/saga-green/theme.css' //theme
import 'primevue/resources/primevue.min.css' //core css
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import 'boxicons';

require('./assets/css/style.css');

const app = createApp(App);
app.use(PrimeVue)

app.component('DataView', DataView)
app.component('DataViewLayoutOptions', DataViewLayoutOptions)
app.component('Panel', Panel)
app.component('Dropdown', Dropdown)
app.component('Dialog', Dialog)
app.component('InputText', InputText)
app.component('Button', Button)
app.component('FilterMatchMode', FilterMatchMode)
app.component('FilterOperator', FilterOperator)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.component('DynamicDialog', DynamicDialog)
app.component('Sidebar', Sidebar)
app.component('ScrollPanel', ScrollPanel)


// createApp(App).mount('#app')
app.mount('#app')

